import React from "react";

const Preloader = ({ global, classes, loading }) => {
  return (
    <div className={`preloader ${global ? "preloader-site" : "preloader-component"} ${loading ? "" : "hide"} ${classes ? classes : ""}`}>
      <div id="loader" />
    </div>
  );
};

export default Preloader;
